<template>
    <section class="chat-modal-btn-sec">
        <button class="chat-modal-btn" data-bs-toggle="modal" data-bs-target="#usernamemodal" @click="toggleChatModal()"
            ref="chatOpenCloaseBtn" aria-label="Open chat">
            <img loading="lazy" src="@/assets/images/message-share.svg" alt="Open chat">
        </button> 
    </section>
    <div class="modal fade" id="usernamemodal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        data-bs-keyboard="false" data-bs-backdrop="static">
        <div class="modal-dialog  thm-chat-modal-sec">
            <div class="modal-content">
                <iframe id="chat_modal" :src="iframeUrl" marginwidth="0" marginheight="0" frameborder="0" width="100%"
                    height="100%" scrolling="no" allowfullscreen="allowfullscreen" v-if="showChat"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ChatComponent',
    data() {
        return {
            showChat: false,
            user_id: null,
            iframeUrl: null,
        }
    },
    mounted() {
        const guestUserName = localStorage.getItem('guestUserName')
        if (guestUserName && !this.$auth?.user?.userid && !this.$auth?.status) {
            this.user_id = guestUserName;
        } else {
            this.user_id = this.$auth?.user?.userid
        }
    },
    methods: {
        async toggleChatModal() {
            const userid = this.user_id;
            const apiEndpoint = this.$auth?.status ? 'GET_CHATBOT_IFRAME' : 'GET_CHATBOT_IFRAME_GUEST';
            const requestData = userid && !this.$auth?.status ? { userid } : {};

            this.$apiCall('post', apiEndpoint, requestData).then(response => {
                    window.addEventListener('message', this.handleMessage);
                    this.iframeUrl = response.data.chat_bot_url;
                })
                .catch(error => {
                    this.$errorToast(error);
                });

            this.showChat = !this.showChat;
        },
        handleMessage(event) {
            if (event.data.userName) {
                this.user_id = event.data.userName;
                localStorage.setItem('guestUserName', this.user_id)
            }
            if (event.data === 'closeChatModal') {
                this.$refs.chatOpenCloaseBtn.click();
                window.removeEventListener('message', this.handleMessage);
            }
        },
    }

}
</script>

<style>
.chat-back-arrow {
    height: 15px;
    vertical-align: text-top;
}

@media screen and (max-width: 575px) {
    .modal-dialog.thm-chat-modal-sec {
        margin: 0 !important;
    }
}

</style>